import { put, call } from 'redux-saga/effects';
import { GetEmployeeFaceTimeHelper, GetEmployeeProfileHelper, GetEmployeeTimeHelper } from '../../app/Components/Finance/helper/ProfileHelper';
import { AddTaxDeclarationHelper, GetTaxDeclarationExecutiveHelper, GetTaxDeclarationHelper, GetTaxEmployeeToggleInfoHelper, UpdateTaxDeclarationExecutiveHelper, UpdateTaxDeclarationHelper, UpdateTaxEmployeeToggleInfonHelper } from '../../app/Components/Finance/helper/TaxDeclarationHelper';
import * as ActionTypes from './ActionTypes';
import {
    AddECMSComponentsHelper,
    AddLeaveWageHelper,
    AddOverTimeHelper,
    AddPHAllowanceHelper,
    AddPostAdjustmentComponentsHelper,
    AddSalaryComponentHelper,
    AddSalaryStructureHelper,
    AddTransportAllowanceHelper,
    DeleteECMSComponentsHelper,
    DeleteLeaveWageHelper,
    DeleteOverTimeHelper,
    DeletePHAllowanceHelper,
    DeletePostAdjustmentComponentsHelper,
    DeleteSalaryComponentHelper,
    DeleteSalaryStructureHelper,
    DeleteTransportAllowanceHelper,
    GetECMSComponentsHelper,
    GetFoodAllowanceHelper,
    GetLeaveWageHelper,
    GetOverTimeHelper,
    GetPayDateHelper,
    GetPayrollApproverHelper,
    GetPHAllowanceHelper,
    GetBonusConfigurationHelper,
    GetPostAdjustmentComponentsHelper,
    GetSalaryComponentHelper,
    GetSalaryComponentTypeHelper,
    GetSalaryStructureHelper,
    GetTransportAllowanceHelper,
    UpdateECMSComponentsHelper,
    UpdateFoodAllowanceHelper,
    UpdateLeaveWageHelper,
    UpdateOverTimeHelper,
    UpdatePayDateHelper,
    UpdatePayrollApproverHelper,
    UpdatePHAllowanceHelper,
    UpdateBonusConfigurationHelper,
    UpdatePostAdjustmentComponentsHelper,
    UpdateSalaryComponentHelper,
    UpdateSalaryStructureHelper,
    UpdateTransportAllowanceHelper
} from '../../app/Components/FinanceSettings/helper/finance';
import { GetCustomDeductionHelper, GetCustomEarningHelper, GetDeductionHelper, GetEarningHelper } from '../../app/Components/Finance/helper/Component/ComponentHelper';
import { AddLWFHelper, AddPayrollTemplateHelper, DeleteLWFHelper, DeletePayrollTemplateHelper, GetPayrollSettingsHelper, GetPayrollTemplateHelper, UpdateLWFHelper, UpdatePayrollTemplateHelper } from '../../app/Components/FinanceSettings/helper/PayRollTemplateHelper';
import { AddCalculateEmployeeSalaryTemplateHelper, AddEmployeeTemplateHelper, CalculateEmployeeSalaryTemplateHelper, GetCalculateEmployeeSalaryTemplateHelper, GetEmployeeTemplateHelper, UpdateEmployeeTemplateHelper } from '../../app/Components/Finance/helper/Employee/EmployeeTemplateHelper';
import { GetContractualWageReportHelper, GetContractualWageReportNotProcessedHelper, GetDailyWageReportHelper, GetDailyWageReportNotProcessedHelper, GetWageReportHelper, GetWageReportNotProcessedHelper } from '../../app/Components/Finance/helper/Reports/GetWageReportHelper';
import { AddEmployeePostAdjustmentHelper, DeleteEmployeePostAdjustmentHelper, GetEmployeePostAdjustmentHelper, GetPayrollReportingEmployeeHelper, UpdateEmployeePostAdjustmentHelper } from '../../app/Components/Finance/helper/PostAdjustment/EmployeePostAdjustmentHelper';
import { AddExpenseSubtypeHelper, AddExpenseTypeHelper, DeleteExpenseSubtypeHelper, DeleteExpenseTypeHelper, GetExpenseSubtypeHelper, GetExpenseTypeHelper, UpdateExpenseSubtypeHelper, UpdateExpenseTypeHelper } from '../../app/Components/ExpenseSettings/helper/ExpenseTypeHelper';
import { AddEmployeeExpenseHelper, DeleteEmployeeExpenseHelper, GetApproverExpenseHelper, GetEmployeeExpenseHelper, GetExpenseCsvHelper, UpdateApproverExpenseHelper, UpdateEmployeeExpenseHelper } from '../../app/Components/ExpenseManagement/helper/MyExpenseHelper';
import { GetPaySummaryTileViewHelper } from '../../app/Components/Finance/helper/PayrollManagement/PayrollManagement';
import { AddRegistrationNumberHelper, GetRegistrationNumberHelper } from '../../app/Components/FinanceSettings/helper/settingsHelper';
import { AddEmployeeEcmsAdjustmentHelper, DeleteEmployeeEcmsAdjustmentHelper, GetEmployeeEcmsAdjustmentHelper, UpdateEmployeeEcmsAdjustmentHelper } from '../../app/Components/Finance/helper/PayEcms/PayEcmsRunHelper';


export function* GetTaxDeclaration(payload) {
    const response = yield call(GetTaxDeclarationHelper, payload?.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.TAX_DECLARATION_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.TAX_DECLARATION_GET_ERROR, payload: response })
    }
}

export function* AddTaxDeclaration(payload) {
    const response = yield call(AddTaxDeclarationHelper, payload?.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.TAX_DECLARATION_ADD_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.TAX_DECLARATION_ADD_ERROR, payload: response })
    }
}

export function* UpdateTaxDeclaration(payload) {
    const response = yield call(UpdateTaxDeclarationHelper, payload?.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.TAX_DECLARATION_UPDATE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.TAX_DECLARATION_UPDATE_ERROR, payload: response })
    }
}

export function* GetTaxDeclarationExecutive() {
    const response = yield call(GetTaxDeclarationExecutiveHelper)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.TAX_DECLARATION_EXECUTIVE_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.TAX_DECLARATION_EXECUTIVE_GET_ERROR, payload: response })
    }
}

export function* UpdateTaxDeclarationExecutive(payload) {
    const response = yield call(UpdateTaxDeclarationExecutiveHelper, payload?.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.TAX_DECLARATION_EXECUTIVE_UPDATE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.TAX_DECLARATION_EXECUTIVE_UPDATE_ERROR, payload: response })
    }
}

export function* GetTaxEmployeeToggleInfo() {
    const response = yield call(GetTaxEmployeeToggleInfoHelper)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.TAX_EMPLOYEE_TOGGLE_INFO_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.TAX_EMPLOYEE_TOGGLE_INFO_GET_ERROR, payload: response })
    }
}

export function* UpdateTaxEmployeeToggleInfo({params,callback}) {
    const response = yield call(UpdateTaxEmployeeToggleInfonHelper, params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.TAX_EMPLOYEE_TOGGLE_INFO_UPDATE_SUCCESS, payload: response })
        if (callback) callback(null, response);
    } else {
        yield put({ type: ActionTypes.TAX_EMPLOYEE_TOGGLE_INFO_UPDATE_ERROR, payload: response })
        if (callback) callback(response, null);
    }
}
//
export function* GetEmployeeProfile() {
    const response = yield call(GetEmployeeProfileHelper)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_PROFILE_PAYROLL_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_PROFILE_PAYROLL_GET_ERROR, payload: response })
    }
}

export function* GetSalaryStructure() {
    const response = yield call(GetSalaryStructureHelper)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.SALARY_STRUCTURE_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.SALARY_STRUCTURE_GET_ERROR, payload: response })
    }
}

export function* AddSalaryStructure(payload) {
    const response = yield call(AddSalaryStructureHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.SALARY_STRUCTURE_ADD_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.SALARY_STRUCTURE_ADD_ERROR, payload: response })
    }
}

export function* UpdateSalaryStructure(payload) {
    const response = yield call(UpdateSalaryStructureHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.SALARY_STRUCTURE_UPDATE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.SALARY_STRUCTURE_UPDATE_ERROR, payload: response })
    }
}

export function* DeleteSalaryStructure(payload) {
    const response = yield call(DeleteSalaryStructureHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.SALARY_STRUCTURE_DELETE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.SALARY_STRUCTURE_DELETE_ERROR, payload: response })
    }
}

export function* GetSalaryComponent(payload) {
    const response = yield call(GetSalaryComponentHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.SALARY_COMPONENT_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.SALARY_COMPONENT_GET_ERROR, payload: response })
    }
}

export function* AddSalaryComponent(payload) {
    const response = yield call(AddSalaryComponentHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.SALARY_COMPONENT_ADD_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.SALARY_COMPONENT_ADD_ERROR, payload: response })
    }
}

export function* UpdateSalaryComponent(payload) {
    const response = yield call(UpdateSalaryComponentHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.SALARY_COMPONENT_UPDATE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.SALARY_COMPONENT_UPDATE_ERROR, payload: response })
    }
}

export function* DeleteSalaryComponent(payload) {
    const response = yield call(DeleteSalaryComponentHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.SALARY_COMPONENT_DELETE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.SALARY_COMPONENT_DELETE_ERROR, payload: response })
    }
}

export function* GetSalaryComponentType() {
    const response = yield call(GetSalaryComponentTypeHelper)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.SALARY_COMPONENT_TYPE_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.SALARY_COMPONENT_TYPE_GET_ERROR, payload: response })
    }
}


export function* GetEarningComponent(payload) {
    const response = yield call(GetEarningHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PAYROLL_EARNING_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.PAYROLL_EARNING_GET_ERROR, payload: response })
    }
}

export function* GetDeductionComponent(payload) {
    const response = yield call(GetDeductionHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PAYROLL_DEDUCTION_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.PAYROLL_DEDUCTION_GET_ERROR, payload: response })
    }
}

export function* GetCustomEarningComponent(payload) {
    const response = yield call(GetCustomEarningHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PAYROLL_CUSTOM_EARNING_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.PAYROLL_CUSTOM_EARNING_GET_ERROR, payload: response })
    }
}

export function* GetCustomDeductionComponent(payload) {
    const response = yield call(GetCustomDeductionHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PAYROLL_CUSTOM_DEDUCTION_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.PAYROLL_CUSTOM_DEDUCTION_GET_ERROR, payload: response })
    }
}


export function* GetPayrollTemplate(payload) {
    const response = yield call(GetPayrollTemplateHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PAYROLL_TEMPLATE_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.PAYROLL_TEMPLATE_GET_ERROR, payload: response })
    }
}

export function* AddPayrollTemplate(payload) {
    const response = yield call(AddPayrollTemplateHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PAYROLL_TEMPLATE_ADD_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.PAYROLL_TEMPLATE_ADD_ERROR, payload: response })
    }
}

export function* UpdatePayrollTemplate(payload) {
    const response = yield call(UpdatePayrollTemplateHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PAYROLL_TEMPLATE_UPDATE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.PAYROLL_TEMPLATE_UPDATE_ERROR, payload: response })
    }
}

export function* DeletePayrollTemplate(payload) {
    const response = yield call(DeletePayrollTemplateHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PAYROLL_TEMPLATE_DELETE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.PAYROLL_TEMPLATE_DELETE_ERROR, payload: response })
    }
}

export function* GetEmployeeTemplate(payload) {
    const response = yield call(GetEmployeeTemplateHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_TEMPLATE_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_TEMPLATE_GET_ERROR, payload: response })
    }
}

export function* AddEmployeeTemplate(payload) {
    const response = yield call(AddEmployeeTemplateHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_TEMPLATE_ADD_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_TEMPLATE_ADD_ERROR, payload: response })
    }
}

export function* UpdateEmployeeTemplate(payload) {
    const response = yield call(UpdateEmployeeTemplateHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_TEMPLATE_UPDATE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_TEMPLATE_UPDATE_ERROR, payload: response })
    }
}

export function* GetWageReport({params,callback}) {
    const response = yield call(GetWageReportHelper,params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.WAGE_REPORT_GET_SUCCESS, payload: response })
         if (callback) callback(null, response);
    } else {
        yield put({ type: ActionTypes.WAGE_REPORT_GET_ERROR, payload: response })
        if (callback) callback(response, null);
    }
}
export function* GetWageReportNotProcessed(payload) {
    const response = yield call(GetWageReportNotProcessedHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.WAGE_REPORT_NOT_PROCESSED_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.WAGE_REPORT_NOT_PROCESSED_GET_ERROR, payload: response })
    }
}

export function* GetContractualWageReport({params,callback}) {
    const response = yield call(GetContractualWageReportHelper,params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.CONTRACTUAL_WAGE_REPORT_GET_SUCCESS, payload: response })
         if (callback) callback(null, response);
    } else {
        yield put({ type: ActionTypes.CONTRACTUAL_WAGE_REPORT_GET_ERROR, payload: response })
        if (callback) callback(response, null);
    }
}
export function* GetContractualWageReportNotProcessed(payload) {
    const response = yield call(GetContractualWageReportNotProcessedHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.CONTRACTUAL_WAGE_REPORT_NOT_PROCESSED_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.CONTRACTUAL_WAGE_REPORT_NOT_PROCESSED_GET_ERROR, payload: response })
    }
}

export function* GetDailyWageReport({params,callback}) {
    const response = yield call(GetDailyWageReportHelper, params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.DAILY_WAGE_REPORT_GET_SUCCESS, payload: response })
        if (callback) callback(null, response);
    } else {
        yield put({ type: ActionTypes.DAILY_WAGE_REPORT_GET_ERROR, payload: response })
        if (callback) callback(response, null);
    }
}
export function* GetDailyWageReportNotProcessed(payload) {
    const response = yield call(GetDailyWageReportNotProcessedHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.DAILY_WAGE_REPORT_NOT_PROCESSED_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.DAILY_WAGE_REPORT_NOT_PROCESSED_GET_ERROR, payload: response })
    }
}
export function* GetEmployeeTime(payload) {
    const response = yield call(GetEmployeeTimeHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_TIME_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_TIME_GET_ERROR, payload: response })
    }
}

export function* GetEmployeeFaceTime(payload) {
    const response = yield call(GetEmployeeFaceTimeHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.EMPLOYEE_FACE_TIME_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.EMPLOYEE_FACE_TIME_GET_ERROR, payload: response })
    }
}

export function* GetPayrollSettings(payload) {
    const response = yield call(GetPayrollSettingsHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PAYROLL_SETTINGS_COMPONENT_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.PAYROLL_SETTINGS_COMPONENT_GET_ERROR, payload: response })
    }
}

export function* AddLWF(payload) {
    const response = yield call(AddLWFHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.LWF_ADD_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.LWF_ADD_ERROR, payload: response })
    }
}

export function* UpdateLWF(payload) {
    const response = yield call(UpdateLWFHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.LWF_UPDATE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.LWF_UPDATE_ERROR, payload: response })
    }
}

export function* DeleteLWF(payload) {
    const response = yield call(DeleteLWFHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.LWF_DELETE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.LWF_DELETE_ERROR, payload: response })
    }
}

export function* GetOT(payload) {
    const response = yield call(GetOverTimeHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.OT_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.OT_GET_ERROR, payload: response })
    }
}

export function* AddOT(payload) {
    const response = yield call(AddOverTimeHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.OT_ADD_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.OT_ADD_ERROR, payload: response })
    }
}

export function* UpdateOT(payload) {
    const response = yield call(UpdateOverTimeHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.OT_UPDATE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.OT_UPDATE_ERROR, payload: response })
    }
}

export function* DeleteOT(payload) {
    const response = yield call(DeleteOverTimeHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.OT_DELETE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.OT_DELETE_ERROR, payload: response })
    }
}

export function* CalculateEmployeeSalaryTemplate(payload) {
    const response = yield call(CalculateEmployeeSalaryTemplateHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.CALCULATE_EMPLOYEE_TEMPLATE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.CALCULATE_EMPLOYEE_TEMPLATE_ERROR, payload: response })
    }
}

export function* AddCalculateEmployeeSalaryTemplate(payload) {
    const response = yield call(AddCalculateEmployeeSalaryTemplateHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.CALCULATE_EMPLOYEE_TEMPLATE_ADD_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.CALCULATE_EMPLOYEE_TEMPLATE_ADD_ERROR, payload: response })
    }
}

export function* GetCalculateEmployeeSalaryTemplate(payload) {
    const response = yield call(GetCalculateEmployeeSalaryTemplateHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.CALCULATE_EMPLOYEE_TEMPLATE_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.CALCULATE_EMPLOYEE_TEMPLATE_GET_ERROR, payload: response })
    }
}


export function* GetPayDate(payload) {
    const response = yield call(GetPayDateHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PAY_DATE_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.PAY_DATE_GET_ERROR, payload: response })
    }
}

export function* UpdatePayDate(payload) {
    const response = yield call(UpdatePayDateHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PAY_DATE_UPDATE_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.PAY_DATE_UPDATE_ERROR, payload: response })
    }
}
// payroll approver
export function* GetPayrollApprover(payload) {
    const response = yield call(GetPayrollApproverHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PAYROLL_APPROVER_GET_SUCCESS , payload: response })
    } else {
        yield put({ type: ActionTypes.PAYROLL_APPROVER_GET_ERROR, payload: response })
    }
}

export function* UpdatePayrollApprover(payload) {
    const response = yield call(UpdatePayrollApproverHelper, payload.params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PAYROLL_APPROVER_UPDATE_SUCCESS , payload: response })
    } else {
        yield put({ type: ActionTypes.PAYROLL_APPROVER_UPDATE_ERROR , payload: response })
    }
}
export function* GetPayrollTileView({params, callback}) {
    const response = yield call(GetPaySummaryTileViewHelper, params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PAYROLL_TILE_VIEW_GET_SUCCESS, payload: response })
        if (callback) callback(null, response);
    } else {
        yield put({ type: ActionTypes.PAYROLL_TILE_VIEW_GET_ERROR, payload: response })
        if (callback) callback(response, null);
    }
}

// --- Leave Wage Sagas ---
export function* GetLeaveWage(payload) {
    const response = yield call(GetLeaveWageHelper, payload.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.LEAVE_WAGE_GET_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.LEAVE_WAGE_GET_ERROR, payload: response });
    }
}

export function* AddLeaveWage(payload) {
    const response = yield call(AddLeaveWageHelper, payload.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.LEAVE_WAGE_ADD_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.LEAVE_WAGE_ADD_ERROR, payload: response });
    }
}

export function* UpdateLeaveWage(payload) {
    const response = yield call(UpdateLeaveWageHelper, payload.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.LEAVE_WAGE_UPDATE_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.LEAVE_WAGE_UPDATE_ERROR, payload: response });
    }
}

export function* DeleteLeaveWage(payload) {
    const response = yield call(DeleteLeaveWageHelper, payload.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.LEAVE_WAGE_DELETE_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.LEAVE_WAGE_DELETE_ERROR, payload: response });
    }
}
// --- Food Allowance Sagas ---
export function* GetFoodAllowance(payload) {
    const response = yield call(GetFoodAllowanceHelper, payload.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.FOOD_ALLOWANCE_GET_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.FOOD_ALLOWANCE_GET_ERROR, payload: response });
    }
}
export function* UpdateFoodAllowance(payload) {
    const response = yield call(UpdateFoodAllowanceHelper, payload.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.FOOD_ALLOWANCE_UPDATE_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.FOOD_ALLOWANCE_UPDATE_ERROR, payload: response });
    }
}

// --- Transport Allowance Sagas ---
export function* GetTransportAllowance(payload) {
    const response = yield call(GetTransportAllowanceHelper, payload.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.TRANSPORT_ALLOWANCE_GET_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.TRANSPORT_ALLOWANCE_GET_ERROR, payload: response });
    }
}

export function* AddTransportAllowance(payload) {
    const response = yield call(AddTransportAllowanceHelper, payload.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.TRANSPORT_ALLOWANCE_ADD_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.TRANSPORT_ALLOWANCE_ADD_ERROR, payload: response });
    }
}

export function* UpdateTransportAllowance(payload) {
    const response = yield call(UpdateTransportAllowanceHelper, payload?.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.TRANSPORT_ALLOWANCE_UPDATE_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.TRANSPORT_ALLOWANCE_UPDATE_ERROR, payload: response });
    }
}

export function* DeleteTransportAllowance(payload) {
    const response = yield call(DeleteTransportAllowanceHelper, payload?.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.TRANSPORT_ALLOWANCE_DELETE_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.TRANSPORT_ALLOWANCE_DELETE_ERROR, payload: response });
    }
}

// --- PH Allowance Sagas ---
export function* GetPHAllowance(payload) {
    const response = yield call(GetPHAllowanceHelper, payload?.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PH_ALLOWANCE_GET_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.PH_ALLOWANCE_GET_ERROR, payload: response });
    }
}

export function* AddPHAllowance(payload) {
    const response = yield call(AddPHAllowanceHelper, payload?.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PH_ALLOWANCE_ADD_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.PH_ALLOWANCE_ADD_ERROR, payload: response });
    }
}

export function* UpdatePHAllowance(payload) {
    const response = yield call(UpdatePHAllowanceHelper, payload?.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PH_ALLOWANCE_UPDATE_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.PH_ALLOWANCE_UPDATE_ERROR, payload: response });
    }
}

export function* GetBonusConfiguration(payload) {
    const response = yield call(GetBonusConfigurationHelper, payload?.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.BONUS_CONFIGURATION_GET_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.BONUS_CONFIGURATION_GET_ERROR, payload: response });
    }
}

export function* UpdateBonusConfiguration(payload) {
    const response = yield call(UpdateBonusConfigurationHelper, payload?.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.BONUS_CONFIGURATION_UPDATE_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.BONUS_CONFIGURATION_UPDATE_ERROR, payload: response });
    }
}

export function* DeletePHAllowance(payload) {
    const response = yield call(DeletePHAllowanceHelper, payload?.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.PH_ALLOWANCE_DELETE_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.PH_ALLOWANCE_DELETE_ERROR, payload: response });
    }
}

export function* GetPostAdjustmentComponents(payload) {
    const response = yield call(GetPostAdjustmentComponentsHelper, payload?.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.ADJUSTMENT_COMPONENTS_GET_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.ADJUSTMENT_COMPONENTS_GET_ERROR, payload: response });
    }
}

export function* AddPostAdjustmentComponents(payload) {
    const response = yield call(AddPostAdjustmentComponentsHelper, payload?.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.ADJUSTMENT_COMPONENTS_ADD_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.ADJUSTMENT_COMPONENTS_ADD_ERROR, payload: response });
    }
}

export function* UpdatePostAdjustmentComponents(payload) {
    const response = yield call(UpdatePostAdjustmentComponentsHelper, payload?.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.ADJUSTMENT_COMPONENTS_UPDATE_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.ADJUSTMENT_COMPONENTS_UPDATE_ERROR, payload: response });
    }
}

export function* DeletePostAdjustmentComponents(payload) {
    const response = yield call(DeletePostAdjustmentComponentsHelper, payload?.params);
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.ADJUSTMENT_COMPONENTS_DELETE_SUCCESS, payload: response });
    } else {
        yield put({ type: ActionTypes.ADJUSTMENT_COMPONENTS_DELETE_ERROR, payload: response });
    }
}
export function* GetPayrollReportingEmployee(payload) {
  const response = yield call(GetPayrollReportingEmployeeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.PAYROLL_REPORTING_EMPLOYEE_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.PAYROLL_REPORTING_EMPLOYEE_GET_ERROR, payload: response });
  }
}

export function* GetEmployeePostAdjustment(payload) {
  const response = yield call(GetEmployeePostAdjustmentHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_POST_ADJUSTMENT_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_POST_ADJUSTMENT_GET_ERROR, payload: response });
  }
}

export function* AddEmployeePostAdjustment(payload) {
  const response = yield call(AddEmployeePostAdjustmentHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_POST_ADJUSTMENT_ADD_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_POST_ADJUSTMENT_ADD_ERROR, payload: response });
  }
}

export function* UpdateEmployeePostAdjustment(payload) {
  const response = yield call(UpdateEmployeePostAdjustmentHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_POST_ADJUSTMENT_UPDATE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_POST_ADJUSTMENT_UPDATE_ERROR, payload: response });
  }
}
export function* DeleteEmployeePostAdjustment(payload) {
  const response = yield call(DeleteEmployeePostAdjustmentHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_POST_ADJUSTMENT_DELETE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_POST_ADJUSTMENT_DELETE_ERROR, payload: response });
  }
}
// leave management
export function* GetExpenseType(payload) {
  const response = yield call(GetExpenseTypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EXPENSE_TYPE_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EXPENSE_TYPE_GET_ERROR, payload: response });
  }
}

export function* AddExpenseType({params,callback}) {
  const response = yield call(AddExpenseTypeHelper, params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EXPENSE_TYPE_ADD_SUCCESS, payload: response });
    if (callback) callback(null, response);
  } else {
    yield put({ type: ActionTypes.EXPENSE_TYPE_ADD_ERROR, payload: response });
    if (callback) callback(response, null);
  }
}

export function* UpdateExpenseType(payload) {
  const response = yield call(UpdateExpenseTypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EXPENSE_TYPE_UPDATE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EXPENSE_TYPE_UPDATE_ERROR, payload: response });
  }
}

export function* DeleteExpenseType({params,callback}) {
  const response = yield call(DeleteExpenseTypeHelper, params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EXPENSE_TYPE_DELETE_SUCCESS, payload: response });
    if (callback) callback(null, response);
  } else {
    yield put({ type: ActionTypes.EXPENSE_TYPE_DELETE_ERROR, payload: response });
    if (callback) callback(response, null);
  }
}


export function* GetExpenseSubtype(payload) {
  const response = yield call(GetExpenseSubtypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EXPENSE_SUBTYPE_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EXPENSE_SUBTYPE_GET_ERROR, payload: response });
  }
}

export function* AddExpenseSubtype(payload) {
  const response = yield call(AddExpenseSubtypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EXPENSE_SUBTYPE_ADD_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EXPENSE_SUBTYPE_ADD_ERROR, payload: response });
  }
}

export function* UpdateExpenseSubtype(payload) {
  const response = yield call(UpdateExpenseSubtypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EXPENSE_SUBTYPE_UPDATE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EXPENSE_SUBTYPE_UPDATE_ERROR, payload: response });
  }
}

export function* DeleteExpenseSubtype(payload) {
  const response = yield call(DeleteExpenseSubtypeHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EXPENSE_SUBTYPE_DELETE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EXPENSE_SUBTYPE_DELETE_ERROR, payload: response });
  }
}
// employee expense
export function* GetEmployeeExpense(payload) {
  const response = yield call(GetEmployeeExpenseHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_EXPENSE_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_EXPENSE_GET_ERROR, payload: response });
  }
}

export function* AddEmployeeExpense({params,callback}) {
  const response = yield call(AddEmployeeExpenseHelper, params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_EXPENSE_ADD_SUCCESS, payload: response });
    if (callback) callback(null, response);
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_EXPENSE_ADD_ERROR, payload: response });
    if (callback) callback(response, null);
  }
}

export function* UpdateEmployeeExpense(payload) {
  const response = yield call(UpdateEmployeeExpenseHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_EXPENSE_UPDATE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_EXPENSE_UPDATE_ERROR, payload: response });
  }
}

export function* DeleteEmployeeExpense(payload) {
  const response = yield call(DeleteEmployeeExpenseHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_EXPENSE_DELETE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_EXPENSE_DELETE_ERROR, payload: response });
  }
}

// approver expense
export function* GetApproverExpense(payload) {
  const response = yield call(GetApproverExpenseHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.APPROVER_EXPENSE_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.APPROVER_EXPENSE_GET_ERROR, payload: response });
  }
}

export function* UpdateApproverExpense(payload) {
  const response = yield call(UpdateApproverExpenseHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.APPROVER_EXPENSE_UPDATE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.APPROVER_EXPENSE_UPDATE_ERROR, payload: response });
  }
}

export function* GetEmployeeExpenseCsv(payload) {
  const response = yield call(GetExpenseCsvHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_EXPENSE_CSV_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_EXPENSE_CSV_GET_ERROR, payload: response });
  }
}
// orgnization reg. number
export function* GetRegistrationNumber() {
    const response = yield call(GetRegistrationNumberHelper)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.REGISTRATION_NUMBER_GET_SUCCESS, payload: response })
    } else {
        yield put({ type: ActionTypes.REGISTRATION_NUMBER_GET_ERROR, payload: response })
    }
}

export function* AddRegistrationNumber({ params, callback }) {
    const response = yield call(AddRegistrationNumberHelper, params)
    if (response?.data?.statuscode === 200) {
        yield put({ type: ActionTypes.REGISTRATION_NUMBER_ADD_SUCCESS, payload: response })
        if (callback) callback(null, response)
    } else {
        yield put({ type: ActionTypes.REGISTRATION_NUMBER_ADD_ERROR, payload: response })
        if (callback) callback(response, null)
    }
}

// --- Get ECMS Adjustment Components ---
export function* GetECMSComponents(payload) {
  const response = yield call(GetECMSComponentsHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.ECMS_COMPONENTS_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.ECMS_COMPONENTS_GET_ERROR, payload: response });
  }
}

export function* AddECMSComponents(payload) {
  const response = yield call(AddECMSComponentsHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.ECMS_COMPONENTS_ADD_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.ECMS_COMPONENTS_ADD_ERROR, payload: response });
  }
}

export function* UpdateECMSComponents(payload) {
  const response = yield call(UpdateECMSComponentsHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.ECMS_COMPONENTS_UPDATE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.ECMS_COMPONENTS_UPDATE_ERROR, payload: response });
  }
}

export function* DeleteECMSComponents(payload) {
  const response = yield call(DeleteECMSComponentsHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.ECMS_COMPONENTS_DELETE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.ECMS_COMPONENTS_DELETE_ERROR, payload: response });
  }
}

export function* GetEmployeeEcmsAdjustment(payload) {
  const response = yield call(GetEmployeeEcmsAdjustmentHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_GET_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_GET_ERROR, payload: response });
  }
}

export function* AddEmployeeEcmsAdjustment(payload) {
  const response = yield call(AddEmployeeEcmsAdjustmentHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_ADD_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_ADD_ERROR, payload: response });
  }
}

export function* UpdateEmployeeEcmsAdjustment(payload) {
  const response = yield call(UpdateEmployeeEcmsAdjustmentHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_UPDATE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_UPDATE_ERROR, payload: response });
  }
}

export function* DeleteEmployeeEcmsAdjustment(payload) {
  const response = yield call(DeleteEmployeeEcmsAdjustmentHelper, payload?.params);
  if (response?.data?.statuscode === 200) {
    yield put({ type: ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_DELETE_SUCCESS, payload: response });
  } else {
    yield put({ type: ActionTypes.EMPLOYEE_ECMS_ADJUSTMENT_DELETE_ERROR, payload: response });
  }
}